import React, { useState } from "react";
import classes from "./Credit.module.scss";
import ButtonComponent from "../../ButtonComponent";
import { COLORS } from "../../../lib/colors";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import { useTranslation } from "react-i18next";
import { useUserState } from "../../../providers/UserProvider";
import ModalComponent from "../../ModalComponent";
import { Input } from "../../Input";
// import { useForm } from "react-hook-form";
import * as Toast from "../../../lib/toast";
import * as HTTPServices from "../../../api/HTTPServices";
import { Radio, RadioGroup, FormControlLabel } from "@mui/material";
import { useForm } from "react-hook-form";

function Credit() {
  const { t } = useTranslation();
  const user = useUserState();
  const { register, handleSubmit } = useForm();
  const [amount, setAmount] = useState();
  const [type, setType] = useState("refundAllRequest");

  const creadit = user.user_login.credit || "0";
  const [showCreditModal, setShowCreditModal] = useState(false);
  const [showWithdrawModal, setshowWithdrawModal] = useState(false);
  const [loading, setloading] = useState(false);
  const [value, setvalue] = useState("");

  function isNumeric(str) {
    if (typeof str != "string") return false; // we only process strings!
    return (
      !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
      !isNaN(parseFloat(str))
    ); // ...and ensure strings of whitespace fail
  }

  const onSubmit = () => {
    setloading(true);
    if (!value) {
      setloading(false);
      return Toast.ErrorData("please enter value");
    }
    let isNumber = isNumeric(value);
    if (!isNumber) {
      setloading(false);
      return Toast.ErrorData("enter number only");
    }
    let formData = new FormData();

    formData.append("price", value);

    const RequestService = HTTPServices.postMethod(
      "increase_credit",
      formData,
      "true"
    );
    RequestService.then(function (response) {
      if (response) {
        Toast.SuccessData("redirecting to pay link");
        setloading(false);
        window.location.href = response.pay_link;
      } else {
      }
    }).catch(function (error) {
      setloading(false);
    });
  };
  const handleChange = (e) => {
    setType(e.target.value);
  };
  const handleChangeIncrease = (e) => {
    setvalue(e.target.value);
  };

  const handleShowWithdrawModal = () => {
    setShowCreditModal(false);
    setshowWithdrawModal(true);
  };

  const handleChangeAmount = (event) => {
    if (event.target.value === "e") {
      event.preventDefault();
    }
    let value = event.target.value;
    value.replace(/[^0-9a-z]/gi, "");
    setAmount(value);
  };

  const onSubmitWithdraw = (data) => {
    console.log(`data`, data);
    try {
      let params = new FormData();
      if (value === "refundAllRequest") {
        params.append("amount", user.UserLogin.credit);
      } else if (value === "refundPartlyRequest" && amount !== undefined) {
        if (amount === "0") {
          // setLoading(false);
          // Helper.ErrorData("as");
          return;
        } else if (Number(amount) > user.UserLogin.credit) {
          // setLoading(false);
          // Helper.ErrorData("asas");
          return;
        } else if (Number(amount) < 50000) {
          // setLoading(false);
          // Helper.ErrorData("asas");
          return;
        } else if (amount.toUpperCase() !== amount.toLowerCase()) {
          // setLoading(false);
          // Helper.ErrorData("Do not insert letters");
          return;
        } else {
          params.append("amount", amount);
        }
      } else if (Number(amount) === undefined) {
        // setLoading(false);
        // Helper.ErrorData("Do not insert letters");
        return;
      } else {
        params.append("amount", amount);
      }
      const RequestService = HTTPServices.postMethod(
        "user_refund",
        params,
        "true"
      );
      RequestService.then(function (response) {
        if (response) {
          console.log(`response`, response);
          // setLoading(false);
          // Helper.SuccessData(response.message);
        }
      });
    } catch (error) {
      // setLoading(false);
    }
  };

  return (
    <div className={classes.mainContainer}>
      <ButtonComponent
        onClick={() => {
          setShowCreditModal(true);
        }}
        backgroundColor={COLORS.secondry}
        width={100}
      >
        {t("components.Layout.credit.btn")}
      </ButtonComponent>
      <span className={classes.creditRemain}>{creadit}</span>
      <AccountBalanceWalletIcon color="primary" />
      <ModalComponent
        open={showCreditModal}
        handleClose={() => {
          setShowCreditModal(false);
        }}
        closeBtn={true}
        // confirmBtn={true}
        title={t("components.Layout.credit.title")}
      >
        <div className={classes.modalContentContainer}>
          <p>{t("components.Layout.credit.account")}</p>
          <p>your creadit is {creadit} $ </p>
          <Input
            name="IncreaseCredit"
            onChange={handleChangeIncrease}
            required
            value={value}
            label={t("components.Layout.credit.input")}
          />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <ButtonComponent
              backgroundColor={COLORS.purple}
              onClick={onSubmit}
              width={200}
              loading={loading}
              disabled={loading}
              style={{ margin: 10 }}
              className={classes.btns}
            >
              confirm pay
            </ButtonComponent>

            <ButtonComponent
              backgroundColor={COLORS.yellow}
              onClick={handleShowWithdrawModal}
              width={200}
              loading={loading}
              disabled={loading}
              className={classes.btns}
            >
              withdraw request
            </ButtonComponent>
          </div>
        </div>
      </ModalComponent>

      <ModalComponent
        open={showWithdrawModal}
        handleClose={() => {
          setshowWithdrawModal(false);
        }}
        closeBtn={true}
        // confirmBtn={true4 v cftr
        title={t("pages.protectedPages.withdrawalRequest.title")}
      >
        <div style={{ padding: 20, textAlign: "center" }}>
          <h3 className={classes.title}>
            {t("pages.protectedPages.withdrawalRequest.title")}
          </h3>
          <hr></hr>
          <div className={classes.formContainer}>
            <div className={classes.inerContainer}>
              <div>{t("pages.protectedPages.withdrawalRequest.credit")} 0</div>

              <form onSubmit={handleSubmit(onSubmit)}>
                <RadioGroup
                  className="canselType"
                  aria-label="canselType"
                  name="canselType"
                  value={type}
                  onChange={handleChange}
                >
                  <FormControlLabel
                    value="refundAllRequest"
                    control={<Radio />}
                    label={t("pages.protectedPages.withdrawalRequest.total")}
                  />
                  <FormControlLabel
                    value="refundPartlyRequest"
                    control={<Radio />}
                    label={t("pages.protectedPages.withdrawalRequest.part")}
                  />
                </RadioGroup>
                {type === "refundPartlyRequest" && (
                  <div>
                    <div>
                      <Input
                        autoFocus={true}
                        autoComplete="off"
                        id="price"
                        name="price"
                        type="number"
                        {...register("amount", { required: true })}
                        label={t(
                          "pages.protectedPages.withdrawalRequest.desire"
                        )}
                        value={amount}
                        onChange={handleChangeAmount}
                      />
                    </div>
                  </div>
                )}

                <div>
                  <ButtonComponent
                    backgroundColor={COLORS.yellow}
                    type="submit"
                    onClick={handleSubmit(onSubmitWithdraw)}
                  >
                    {t("pages.protectedPages.withdrawalRequest.button")}
                  </ButtonComponent>
                </div>
              </form>
            </div>
          </div>
        </div>
      </ModalComponent>
    </div>
  );
}

export default Credit;
